export const SUCCESS = 200;
export const NO_CONTENT = 204;
export const BAD_REQUEST = 400;
export const UNAUTHORISED = 401;
export const NOT_FOUND = 404;